import { render, staticRenderFns } from "./inputveditor.vue?vue&type=template&id=2101f530&"
import script from "./inputveditor.vue?vue&type=script&lang=js&"
export * from "./inputveditor.vue?vue&type=script&lang=js&"
import style0 from "./inputveditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports